import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "./Header";
import MobileLayoutRenderer from "../../../../pages/mobile/layout/MobileLayoutRenderer";
import { useTranslation } from "react-i18next";
import listening_icon from "../../../../assets/images/listening_icon.svg";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { FaMicrophone } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import InputHints from "react-input-hints";
import Podcast from "../../../../assets/icons/podcast3.gif";
import "../../../../assets/styles/pages/mobilehomepage.scss";
import { debounce } from "lodash";
import { apiJson } from "../../../../Api";
import { toast } from "react-toastify";
import { useHistory, useLocation, Link } from "react-router-dom";
import { connect } from "react-redux";
import { set_home_categories } from "../../../../redux/actions/HomeAction";
import {
  set_country,
  set_loading,
} from "../../../../redux/actions/LayoutAction";
import { set_cart_items } from "../../../../redux/actions/CartAction";
import { set_search } from "../../../../redux/actions/HeaderAction";
import { set_redirect_home } from "../../../../redux/actions/NotFoundAction";
import { set_user } from "../../../../redux/actions/AuthAction";
import SearchPopoverMobile from "../../../header/SearchPopoverMobile";
import EngineerIcon from "../../../../assets/images/homepage/engineer.png";
import MarketingIcon from "../../../../assets/images/homepage/marketing.png";

import CatalogIcon from "../../../../assets/images/homepage/catalog-icon.png";
import b2bIcon from "../../../../assets/images/homepage/b2b.png";
import topcat1 from "../../../../assets/images/homepage/topcat1.png";
import topcat2 from "../../../../assets/images/homepage/topcat2.png";
import topcat4 from "../../../../assets/images/homepage/topcat4.png";

import cat1 from "../../../../assets/images/homepage/cat1.png";
import cat2 from "../../../../assets/images/homepage/cat2.png";
import cat3 from "../../../../assets/images/homepage/cat3.png";
import cat4 from "../../../../assets/images/homepage/cat4.png";
import cat5 from "../../../../assets/images/homepage/cat5.png";
import cat6 from "../../../../assets/images/homepage/cat6.png";
import cat7 from "../../../../assets/images/homepage/cat7.png";
import cat8 from "../../../../assets/images/homepage/cat8.png";
import cat9 from "../../../../assets/images/homepage/cat9.png";
import cat10 from "../../../../assets/images/homepage/cat10.png";
import cat11 from "../../../../assets/images/homepage/cat11.png";
import cat12 from "../../../../assets/images/homepage/cat12.png";
import cat13 from "../../../../assets/images/homepage/cat13.png";
import cat14 from "../../../../assets/images/homepage/cat14.png";
import cat15 from "../../../../assets/images/homepage/cat15.png";
import cat16 from "../../../../assets/images/homepage/cat16.png";
import cat17 from "../../../../assets/images/homepage/cat17.png";
import cat18 from "../../../../assets/images/homepage/cat18.png";
import cat19 from "../../../../assets/images/homepage/cat19.png";
import cat20 from "../../../../assets/images/homepage/cat20.png";

import Banner1 from "../../../../assets/images/homepage/Col3Banner1.jpg";
import Banner2 from "../../../../assets/images/homepage/IGLOO.png";
import Banner3 from "../../../../assets/images/homepage/summerbanner.png";
import MobileWebsiteFooter from "../../../Footer/2025/MobileWebsiteFooter";

import { Swiper, SwiperSlide } from "swiper/react";
import { useOutsideAlerter } from "../../../../utils/CustomHooks";
import { set_all_items } from "../../../../redux/actions/AllItemsAction";

const categories = [
  { img: cat1, id: 183 },
  { img: cat2, id: 193 },
  { img: cat3, id: 182 },
  { img: cat4, id: 184 },
  { img: cat5, id: 188 },
  { img: cat6, id: 189 },
  { img: cat7, id: 192 },
  { img: cat8, id: 190 },
  { img: cat9, id: 185 },
  { img: cat10, id: 187 },
  { img: cat11, id: 194 },
  { img: cat12, id: 191 },
  { img: cat13, id: 186 },
  { img: cat14, id: 590 },
  { img: cat15, id: 526 },
  { img: cat16, id: 618 },
  { img: cat17, id: 196 },
  { img: cat18, id: 467 },
  { img: cat19, id: 669 },
  { img: cat20, id: 227 },
];

const desktopBanners = [
  {
    image:
      "https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/2fEhD4PZ6U9otCPziNSWc1.png",
  },
  {
    image:
      "https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/eAbsfmAjqfe4k7kuXxMGr5.png",
  },
];

function MobileHomePage(props) {
  const [searching, setSearching] = useState(false);
  const [isSearchClick, setIsSearchClick] = useState(false);
  const [recentSearch, setrecentSearch] = useState([]);
  const [recentvalue, setrecentvalue] = useState("");
  const [loader, setLoader] = useState(false);

  const { t } = useTranslation();
  const searchRef = useRef(null);
  const history = useHistory();
  const location = useLocation();

  let sections = [];

  useOutsideAlerter(searchRef, setIsSearchClick);

  const { transcript, listening, resetTranscript } = useSpeechRecognition();

  useEffect(() => {
    if (transcript) {
      setrecentvalue(transcript);
      setIsSearchClick(true);
    }

    !listening && transcript && performSearch(transcript);
  }, [transcript, listening]);

  const debouncedCallback = useCallback(
    debounce((text) => performSearch(text), 1000),
    []
  );

  const performSearch = function (text) {
    text = text.replace("&", "");

    let product_type = window.location.href.includes("/wholesale")
      ? "wholesale"
      : "retail";

    apiJson.header
      .search(props.countryId, text.trim().replace(/\s\s+/g, " "), product_type)
      .then(function (response) {
        setSearching(false);
        if (response.success) {
          props.set_search({
            searchCat: response.data.categories,
            searchBrands: response.data.brands,
            searchProducts: response.data.products,
            searchServices: response.data.services,
          });
        } else if (!response.status) {
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        } else {
          if (response?.status === 401) {
            props.set_user({ isSignedIn: false, user: {} });
            localStorage.removeItem("access_token");
            localStorage.removeItem("client");
            localStorage.removeItem("uid");
            document.cookie =
              "authHeaders=; path=/; expires=Thu, 21 Aug 2014 20:00:00 UTC";
          } else {
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                ? response.errors
                : t("errors.wrong");
              showError();
            } else {
              if (response.status == 503) {
                message = t("errors.network");
                showError();
              } else {
                message = response.message
                  ? response.message !== ""
                    ? response.message
                    : t("errors.wrong")
                  : t("errors.wrong");
                showError();
              }
            }
          }
        }
      });
  };

  const onSearchBtnClicked = (e) => {
    e.preventDefault();
    setIsSearchClick(false);

    history.push({
      pathname:
        "/" +
        props.countryUrl +
        "-" +
        props.language +
        "/search/products?q=" +
        recentvalue.replace("&", "_"),
      state: location.state,
    });
  };

  const clearRecentHistory = () =>
    apiJson.header.clearHistory().then((response) => {
      setLoader(false);
      if (response.success) {
        setrecentSearch([]);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : t("errors.wrong")
          : t("errors.wrong");
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : t("errors.wrong");
          showError();
        } else {
          if (response.status == 503) {
            message = t("errors.network");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      }
    });

  const deleteRecent = (id) => {
    setLoader(true);
    apiJson.header.deleteRecent(id).then((response) => {
      setLoader(false);
      if (response.success) {
        setrecentSearch(recentSearch.filter((ele) => ele.id !== id));
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : t("errors.wrong")
          : t("errors.wrong");
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : t("errors.wrong");
          showError();
        } else {
          if (response.status == 503) {
            message = t("errors.network");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      }
    });
  };

  const onSeacrhChange = (text) => {
    setIsSearchClick(true);
    setrecentvalue(text);
    if (text.length < 2) {
      return [];
    } else {
      !searching && setSearching(true);
      debouncedCallback(text);
    }
  };
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  function shuffle(array) {
    let currentIndex = array.length,
      randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  const setSection = (section, position, allProducts) => {
    switch (position) {
      case 2:
        props.set_home_categories({
          positionTwo:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 3:
        props.set_home_categories({
          positionThree:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 4:
        props.set_home_categories({
          positionFour:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 5:
        props.set_home_categories({
          positionFive:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 6:
        props.set_home_categories({
          positionSix:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 7:
        props.set_home_categories({
          positionSeven:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 8:
        props.set_home_categories({
          positionEight:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 9:
        props.set_home_categories({
          positionNine:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 10:
        props.set_home_categories({
          positionTen:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 11:
        props.set_home_categories({
          positionEleven:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 12:
        props.set_home_categories({
          positionTwelve:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      case 13:
        props.set_home_categories({
          positionThirteen:
            section?.data?.length < 1
              ? { ...section, data: allProducts }
              : { ...section, data: section.data },
        });
        break;
      default:
        sections.push(section);
    }
  };

  useEffect(() => {
    document.title = "ALISOUQ - Buy All Your Home Needs Online, UAE";
  }, []);

  useEffect(() => {
    apiJson.allitems.getCategories(props.countryId).then((response) => {
      if (response.success) {
        props.set_all_items({
          category: response.data,
        });
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : t("errors.wrong")
          : t("errors.wrong");
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : t("errors.wrong");
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        }
      }
    });

    props.redirect && props?.set_redirect_home(false);
    window.scroll(0, 0);
    props.set_loading(true);
    (localStorage.getItem("access_token") ||
      localStorage.getItem("user_key")) &&
      apiJson.cart.getCartItems(props.countryId).then((response) => {
        if (response.success) {
          props.set_cart_items({ cart_items: response.data });
        } else if (!response.status) {
          // eslint-disable-next-line
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : t("errors.wrong");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      });

    apiJson.homepage.getBanners(props.countryId).then((response) => {
      if (response.success) {
        let primaryBanners = [];
        let secondaryBanners = [];

        response.data.map((banner) =>
          banner.banner_type === "platform_primary"
            ? primaryBanners.push(banner)
            : secondaryBanners.push(banner)
        );
        props.set_home_categories({
          primaryBanners: primaryBanners,
          secondaryBanners: secondaryBanners,
        });
        props.set_loading(false);
      } else if (!response.status) {
        props.set_loading(false);
        message = response.message
          ? response.message !== ""
            ? response.message
            : t("errors.wrong")
          : t("errors.wrong");
        showError();
      } else {
        props.set_loading(false);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : t("errors.wrong");
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        }
      }
    });

    let allProducts = [];

    apiJson.homepage.getFirstSection(props.countryId).then((response) => {
      if (response.success) {
        const temp = {
          title_en: response.data.section.title_en,
          title_ar: response.data.section.title_ar,
          data: [
            ...response.data.section.products,
            ...response.data.section.services,
          ],
        };
        props.set_home_categories({
          positionOne: {
            id: response.data.section.id,
            title_en: response.data.section.title_en,
            title_ar: response.data.section.title_ar,
            data: [
              ...response.data.section.products,
              ...response.data.section.services,
            ],
          },
        });

        let i = 0;
        response.data.section_ids?.map((id) =>
          apiJson.homepage.getSections(id, props.countryId).then((section) => {
            ++i;
            if (i === 1) {
              temp?.data?.length < 1 &&
                props.set_home_categories({
                  positionOne: { ...temp, data: allProducts },
                });
            }
            if (section.success) {
              section.data.title_en !== "Weekly Sale 1" &&
                section.data.title_en !== "Weekly Sale 2" &&
                section.data.title_en !== "Combo Sale 1" &&
                section.data.title_en !== "Combo Sale 2" &&
                section.data.title_en !== "Brand Favourites 1" &&
                section.data.title_en !== "Brand Favourites 2" &&
                section.data.title_en !== "Brand Favourites 3" &&
                section.data.title_en !== "Offers" &&
                setSection(
                  {
                    id: section.data.id,
                    title_en: section.data.title_en,
                    title_ar: section.data.title_ar,
                    data: [...section.data.products, ...section.data.services],
                  },

                  section.data.position ? section.data.position : null,
                  shuffle(allProducts)
                );
              if (i === response.data.section_ids.length) {
                props.set_home_categories({
                  sections: sections,
                });
              }
            }
          })
        );
      }
    });

    apiJson.allitems
      .getItems(props.countryId, "products", 1, 10)
      .then((response) => {
        response.success
          ? (allProducts = response.data.products)
          : (allProducts = []);
      });

    apiJson.homepage.getCategories(props.countryId).then((response) => {
      if (response.success) {
        props.set_home_categories({ categories: response.data });
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : t("errors.wrong")
          : t("errors.wrong");
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : t("errors.wrong");
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        }
      }
    });

    apiJson.cart.guestUser(props.countryId).then((response) => {
      if (response.success) {
        props.set_user({
          guestUser: response.data.platform_settings.guest_user_checkout,
          guestSignin: false,
        });
      } else {
        props.set_user({
          guestUser: false,
        });
      }
    });
  }, [props.countryId]);

  return (
    <div>
      <MobileLayoutRenderer
        NavbarTop={false}
        BackBtn={false}
        CancelBtn={false}
        NavbarBottom={false}
      >
        <div className="newmobilehomepage">
          <Header />
          <div
            style={{
              padding: "2px 0 3px",
              background: "#036",
              textAlign: "center",
            }}
          >
            <span
              style={{
                fontSize: "13px",
                letterSpacing:"1px",
                lineHeight: "100%",
                color: "#FFF",
                display: "block",
              }}
            >
              Free Shipping Above AED 99
            </span>
          </div>
          <div className="product-home-page-mobile">
            <div className="home-banner">
              <div
                className={
                  "mx-auto banner-content" + (listening ? " text-center" : "")
                }
              >
                {listening ? (
                  <>
                    <img src={Podcast} style={{ width: "100px" }} />

                    <p className="searched-text">{recentvalue}</p>
                  </>
                ) : (
                  <>
                    <h2 className="mainheadi">MENA's No.1 Digital Platform in</h2>
                    <h2 className="mainheadi">
                    Building Materials and Construction
                    </h2>
                  </>
                )}
                <div ref={searchRef} className="search-container-wrapper">
                  <form onSubmit={onSearchBtnClicked} className="search-form">
                    {listening ? (
                      <></>
                    ) : (
                      <>
                        <InputHints
                          type="search"
                          onChange={(e) => {
                            onSeacrhChange(e.target.value);
                            !e.target.value && resetTranscript();
                          }}
                          className="form-control"
                          placeholders={[
                            t("homePage.search-ph1"),
                            t("homePage.search-ph2"),
                            t("homePage.search-ph3"),
                            t("homePage.search-ph4"),
                            t("homePage.search-ph5"),
                          ]}
                          aria-label="Search"
                          aria-describedby="search-addon"
                          value={recentvalue}
                          // onClick={handleSearchClcik}
                        />
                        <div className="search-box">
                          {listening ? (
                            <img
                              src={listening_icon}
                              alt="Listening"
                              style={{
                                marginTop: "5px",
                                marginRight: "5px",
                                cursor: "pointer",
                              }}
                              onClick={SpeechRecognition.stopListening}
                            />
                          ) : (
                            <FaMicrophone
                              size="12.78"
                              color="#003366"
                              onClick={SpeechRecognition.startListening}
                              style={{
                                marginRight: "3.22px",
                                cursor: "pointer",
                              }}
                            />
                          )}
                          <span
                            className="search-icon pointer"
                            id="search-addon"
                          >
                            <div className="d-flex justify-content-center align-items-center w-100 h-100">
                              <button
                                className={
                                  props.lang === "ar"
                                    ? "search-btn-ar"
                                    : "search-btn"
                                }
                              >
                                <IoSearchOutline size="12" />
                                <span>Search</span>
                              </button>
                            </div>
                          </span>
                        </div>
                      </>
                    )}

                    {isSearchClick && (
                      <SearchPopoverMobile
                        recent={recentSearch}
                        recentValue={recentvalue}
                        clearHistory={() => {
                          setLoader(true);
                        }}
                        deleteRecent={(id) => deleteRecent(id)}
                        loader={loader}
                        setRecentValue={(val) => onSeacrhChange(val)}
                        searching={searching}
                      />
                    )}
                  </form>
                </div>
              </div>
            </div>
            <div className="divider" />
            <div className="middle-cards-row">
              <div className="custom-card">
                <div>
                  <div className="icon-div">
                    <img src={EngineerIcon} className="engineer-icon" />
                  </div>
                </div>
                <h4 className="title">500+ CONTRACTORS &amp; DEVELOPERS</h4>
              </div>
              <div className="custom-card">
                <div className="icon-div">
                  <img src={CatalogIcon} className="engineer-icon" />
                </div>

                <h4 className="title">PRODUCT CATALOG WITH 250K+ SKUs</h4>
              </div>
              <div className="custom-card">
                <div className="icon-div">
                  <img src={b2bIcon} className="engineer-icon" />
                </div>
                <h4 className="title">SERVING B2B, B2C, B2B2C & B2G</h4>
              </div>
              {/* <div className="custom-card">
                <div className="icon-div">
                  <img
                    src={MarketingIcon}
                    className="marketing engineer-icon "
                  />
                </div>
                <h4 className="title">MARKETING SOLUTIONS</h4>
              </div> */}
            </div>
            <div className="divider" />
            <div className="middle-section">
              <div>
                <h3>Top Categories</h3>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <Link
                      to={{
                        pathname:
                          "/" +
                          props.countryUrl +
                          "-" +
                          props.language +
                          "/items/products",
                        search: "?filter_by_category%5B%5D=182",
                      }}
                    >
                      <img src={topcat1} />
                    </Link>
                  </div>

                  <div>
                    <Link
                      to={{
                        pathname:
                          "/" +
                          props.countryUrl +
                          "-" +
                          props.language +
                          "/items/products",
                        search: "?filter_by_category[]=191",
                      }}
                    >
                      <img src={topcat4} />
                    </Link>
                  </div>
                  <div>
                    <Link
                      to={{
                        pathname:
                          "/" +
                          props.countryUrl +
                          "-" +
                          props.language +
                          "/items/products",
                        search: "?filter_by_category[]=186",
                      }}
                    >
                      <img src={topcat2} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="divider" />

            <div className="discover-building-solutions">
              <h2>
                Your construction project is our priority - let us bring your
                vision to life
              </h2>
              <div className="count-container">
                <div className="count-div">
                  <h3 className="m-0 count">100K+</h3>
                  <p className="m-0">Page Views</p>
                </div>
                <div className="count-div count-border">
                  <h3 className="m-0 count">5000+</h3>
                  <p className="m-0">Brand Partners</p>
                </div>
                <div className="count-div count-border">
                  <h3 className="m-0 count">500+</h3>
                  <p className="m-0">Contractors</p>
                </div>
                <div className="count-div count-border">
                  <h3 className="m-0 count">250K+</h3>
                  <p className="m-0">Products</p>
                </div>
              </div>
            </div>
            <div className="categories-section">
              <div style={{ maxWidth: "320px", height: "120px" }}>
                <Swiper
                  slidesPerView={4}
                  spaceBetween={10}
                  slidesPerColumnFill="row"
                  pagination={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                >
                  {categories.map((category, index) => (
                    <SwiperSlide
                      onClick={(e) => e.preventDefault()}
                      key={index}
                    >
                      <Link
                        to={{
                          pathname: `/${props.countryUrl}-${props.language}/items/products`,
                          search: `?filter_by_category[]=${category.id}`,
                        }}
                      >
                        <img
                          className="img-category"
                          src={category.img}
                          alt={`Category ${index + 1}`}
                        />
                      </Link>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>

            <div className="divider" />

            <div className="top-brands">
              <h2 className="mainheadi">Top Brands</h2>
              <Swiper
                slidesPerView={4}
                pagination={{ clickable: true }}
                spaceBetween={15}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                className="custom-swiper"
              >
                <SwiperSlide>
                  <Link
                    to={{
                      pathname:
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/items/products",
                      search: "?filter_by_brand%5B%5D=42",
                    }}
                  >
                    <img src="https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/wmo9bcqbAN7dHV4ZpFYcCE.png" />
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link
                    to={{
                      pathname:
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/items/products",
                      search: "?filter_by_brand%5B%5D=44",
                    }}
                  >
                    <img src="https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/2gbCVfRpwUsgffJzgihfmH.png" />
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link
                    to={{
                      pathname:
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/items/products",
                      search: "?filter_by_brand%5B%5D=164",
                    }}
                  >
                    <img src="https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/peSAhEhokenQ9EjtR2YGq7.png" />
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link
                    to={{
                      pathname:
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/items/products",
                      search: "?filter_by_brand%5B%5D=281",
                    }}
                  >
                    <img src="https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/xkavF6T544k2JgQk6wLMMN.png" />
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link
                    to={{
                      pathname:
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/items/products",
                      search: "?filter_by_brand%5B%5D=171",
                    }}
                  >
                    <img src="https://alisuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/ep7BhDu7z286wNP262KLtt.png" />
                  </Link>
                </SwiperSlide>
              </Swiper>
            </div>

            <div className="divider" />

            <div className="banners-section">
              <Swiper
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                className="custom-swiper"
              >
                <SwiperSlide>
                  <Link
                    to={`/${props.countryUrl}-${props.language}/summer-is-here`}
                  >
                    <img src={Banner3} alt="Summer Banner" />
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link
                    to={{
                      pathname: `/${props.countryUrl}-${props.language}/items/products`,
                      search: "?filter_by_brand%5B%5D=726",
                    }}
                  >
                    <img src={Banner2} alt="Products Banner" />
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link
                    to={`/${props.countryUrl}-${props.language}/ramadan-sale`}
                  >
                    <img src={Banner1} alt="Ramadan Sale Banner" />
                  </Link>
                </SwiperSlide>
              </Swiper>
            </div>

            <div className="divider" />

            <div className="streamline-ordering">
              <h2>Seamless Onboarding Experience for Our Vendors</h2>
              <div className="cart">
                <h3>Seamless Onboarding</h3>
                <p>
                  Skip the paperwork and hassle—just show up for a meeting! We
                  handle your registration, digital signing, and store setup so
                  you can focus on selling.
                </p>
              </div>
              <div className="cart">
                <h3>Content Magic</h3>
                <p>
                  Forget writing descriptions and editing images—we handle it
                  all! From product catalogs to high-quality images and
                  compelling listings, we ensure your products shine.
                </p>
              </div>
              <div className="cart">
                <h3>Live & Selling</h3>
                <p>
                  No setup, no maintenance—just watch your store thrive! We
                  handle product publishing, marketing, AI-driven pricing, and
                  seamless sales operations.
                </p>
              </div>
              <div className="cart">
                <h3>Dynamic Auto Pricing</h3>
                <p>
                  Maximize profits, boost sales, and lead the market
                  effortlessly. Our 24/7 dynamic pricing software continuously
                  optimizes prices to keep you ahead.
                </p>
              </div>
            </div>

            <div className="divider" />

            <div className="empowering-business">
              <h2 className="warehousetitle">
                Advantages of Partnering with ALISOUQ
              </h2>
              <p>
                ALISOUQ is your one-stop solution for construction materials,
                catering to B2B clients,vendors, andend customers. We help you
                build lasting relationships and seamlessly complete your
                projectswhether they’re large-scale constructions or personal
                DIY endeavors.
              </p>

              <div
                style={{
                  background: "#E9E9E9",
                  height: "105px",
                  margin: "46px 0px 68px",
                  position: "relative",
                }}
              >
                <div style={{ position: "relative", top: "-40px" }}>
                  <Swiper
                    slidesPerView={1}
                    slidesPerColumnFill="row"
                    pagination={true}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                  >
                    <SwiperSlide>
                      <div className="frame mission-section">
                        <div className="tradecontent">
                          <div className="title">OUR MISSION</div>
                          <div className="subtitle">
                            Delivering exceptional service and top-quality
                            products to our partners and clients.
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="frame globe-section">
                        <div
                          className="subtitle"
                          style={{ color: "#51200b" }}
                        ></div>
                        <div className="title"></div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="frame technology-section">
                        <div className="tradecontent">
                          <div className="title">OUR TEAM</div>
                          <div className="subtitle">
                            Meet the Experts Behind the Brand – A Team Dedicated
                            to Your Success!
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>

            <div className="divider" />

            <div className="testimonials">
              <h2 className="warehousetitle mb-0 pb-0">
                Trusted by Industry Leaders
              </h2>
              <div className="mt-3"></div>
              <Swiper
                slidesPerView={1}
                pagination={{
                  clickable: false,
                }}
                navigation
                className="homepage-main-banner-swiper"
                dir="ltr"
              >
                {desktopBanners.map((item, index) => (
                  <SwiperSlide key={index}>
                    <img
                      className="swiper-image"
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      src={item.image}
                      alt=""
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="divider" />
            <div className="popular-categories">
              <h2>Popular Categories</h2>
              <div className="button-container">
                <Link
                  to={{
                    pathname:
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/items/products",
                    search:
                      "?filter_by_category%5B%5D=186&filter_by_category%5B%5D=804&filter_by_category%5B%5D=229&filter_by_category%5B%5D=337&filter_by_category%5B%5D=338&filter_by_category%5B%5D=226&filter_by_category%5B%5D=224&filter_by_category%5B%5D=586&filter_by_category%5B%5D=819&filter_by_category%5B%5D=827&filter_by_category%5B%5D=695&filter_by_category%5B%5D=696&filter_by_category%5B%5D=697&filter_by_category%5B%5D=227&filter_by_category%5B%5D=230&filter_by_category%5B%5D=340&filter_by_category%5B%5D=341&filter_by_category%5B%5D=802&filter_by_category%5B%5D=339&filter_by_category%5B%5D=550&filter_by_category%5B%5D=549&filter_by_category%5B%5D=228&filter_by_category%5B%5D=583&filter_by_category%5B%5D=601&filter_by_category%5B%5D=548&filter_by_category%5B%5D=831&filter_by_category%5B%5D=832&filter_by_category%5B%5D=834&filter_by_category%5B%5D=833&filter_by_category%5B%5D=551&filter_by_category%5B%5D=613&filter_by_category%5B%5D=552&filter_by_category%5B%5D=490&filter_by_category%5B%5D=225&filter_by_category%5B%5D=335&filter_by_category%5B%5D=333&filter_by_category%5B%5D=334&filter_by_category%5B%5D=336&filter_by_category%5B%5D=603&tab=p",
                  }}
                >
                  <button>Electrical</button>
                </Link>
                <Link
                  to={{
                    pathname:
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/items/products",
                    search: "?filter_by_category%5B%5D=185",
                  }}
                >
                  <button>Bath & Faucet </button>
                </Link>
                <Link
                  to={{
                    pathname:
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/items/products",
                    search:
                      "?filter_by_category%5B%5D=191&filter_by_category%5B%5D=259&filter_by_category%5B%5D=388&filter_by_category%5B%5D=389&filter_by_category%5B%5D=390&filter_by_category%5B%5D=391&filter_by_category%5B%5D=392&filter_by_category%5B%5D=393&filter_by_category%5B%5D=394&filter_by_category%5B%5D=395&filter_by_category%5B%5D=396&filter_by_category%5B%5D=397&filter_by_category%5B%5D=262&filter_by_category%5B%5D=418&filter_by_category%5B%5D=417&filter_by_category%5B%5D=257&filter_by_category%5B%5D=381&filter_by_category%5B%5D=382&filter_by_category%5B%5D=383&filter_by_category%5B%5D=384&filter_by_category%5B%5D=260&filter_by_category%5B%5D=402&filter_by_category%5B%5D=404&filter_by_category%5B%5D=398&filter_by_category%5B%5D=399&filter_by_category%5B%5D=400&filter_by_category%5B%5D=401&filter_by_category%5B%5D=403&filter_by_category%5B%5D=261&filter_by_category%5B%5D=405&filter_by_category%5B%5D=406&filter_by_category%5B%5D=407&filter_by_category%5B%5D=408&filter_by_category%5B%5D=409&filter_by_category%5B%5D=410&filter_by_category%5B%5D=411&filter_by_category%5B%5D=412&filter_by_category%5B%5D=413&filter_by_category%5B%5D=414&filter_by_category%5B%5D=415&filter_by_category%5B%5D=416&filter_by_category%5B%5D=258&filter_by_category%5B%5D=385&filter_by_category%5B%5D=386&filter_by_category%5B%5D=387&tab=p",
                  }}
                >
                  <button>Hardware & Tools </button>
                </Link>
                <Link
                  to={{
                    pathname:
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/items/products",
                    search:
                      "?filter_by_category%5B%5D=194&filter_by_category%5B%5D=271&filter_by_category%5B%5D=269&filter_by_category%5B%5D=270&filter_by_category%5B%5D=272&filter_by_category%5B%5D=274&filter_by_category%5B%5D=275&filter_by_category%5B%5D=273&tab=p",
                  }}
                >
                  <button>Paint </button>
                </Link>

                <Link
                  to={{
                    pathname:
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/items/products",
                    search: "?filter_by_category[]=196",
                  }}
                >
                  <button>Roofing </button>
                </Link>
              </div>
            </div>
          </div>

          <MobileWebsiteFooter />
        </div>
      </MobileLayoutRenderer>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    banners: state.home.secondaryBanners,
    countryId: state.language.countryId,
    country: state.language.country,
    recommendedForYou: state.home.recommendedForYou,
    diyProducts: state.home.diyProducts,
    paintersTouch: state.home.paintersTouch,
    krudKutter: state.home.krudKutter,
    sections: state.home.sections,
    positionOne: state.home.positionOne,
    positionTwo: state.home.positionTwo,
    positionThree: state.home.positionThree,
    positionFour: state.home.positionFour,
    positionFive: state.home.positionFive,
    positionSix: state.home.positionSix,
    positionSeven: state.home.positionSeven,
    positionEight: state.home.positionEight,
    positionNine: state.home.positionNine,
    positionTen: state.home.positionTen,
    positionEleven: state.home.positionEleven,
    positionTwelve: state.home.positionTwelve,
    positionThirteen: state.home.positionThirteen,
    language: state.language.language,
    countryUrl: state.language.countryUrl,
    categories: state.header.allCategories,
    redirect: state.notFound.redirect,
    loading: state.layout.loading,
  };
};

const mapDispatchToProps = {
  set_home_categories,
  set_country,
  set_cart_items,
  set_search,
  set_redirect_home,
  set_loading,
  set_user,
  set_all_items,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileHomePage);
